//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"Direction",1,0],[0,"IndicatorType",1,0],[0,"Label",0,"Annotations.DatumReferenceBuilder",0],[0,"Symbol",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.FeatureControlFrameIndicatorBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.FeatureControlFrameIndicatorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.FeatureControlFrameIndicatorBuilder.FcfIndicatorType = Object.freeze({
    "IntersectionPlane" : "IntersectionPlane", "OrientationPlane" : "OrientationPlane", "CollectionPlane" : "CollectionPlane", "DirectionFeature" : "DirectionFeature"});

SPLM.Annotations.FeatureControlFrameIndicatorBuilder.FcfIndicatorCharacteristic = Object.freeze({
    "Parallel" : "Parallel", "Perpendicular" : "Perpendicular", "Angular" : "Angular", "Including" : "Including", "Runout" : "Runout"});

SPLM.Annotations.FeatureControlFrameIndicatorBuilder.FcfIndicatorDirection = Object.freeze({
    "After" : "After", "Before" : "Before"});

export default SPLM;